<template>
    <div align="right">
      <el-table
        ref="multipleTable"
        :data="paginatedData"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        border
        row-key="id"
        class="w idcdb-paginated-table"
        :fit="true"
      >
        <template v-for="col in colData">
          <el-table-column
            :key="col.type"
            :prop="col.type"
            :label="col.label"
            :show-overflow-tooltip="true"
            :align="col.align || 'center'"
        
          >
          </el-table-column>
        </template>
      </el-table>
      <el-pagination
        class="mt10"
        background
        layout="total, sizes, prev, pager, next"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalNum"
        :current-page.sync="currentPage"
        @current-change="changePage"
        @size-change="handleSizeChange"
      >
      </el-pagination>
    </div>
  </template>
  
  <script>

  export default {
    name: 'changeResourceTable',
    props: {
      ResourceData: {
        type: Array,
        required: true,
      },
      colData: {
        type: Array,
        default: [
          {
            type: 'rack_code',
            label: '机架编号',
            minWidth: '15%',
          },
          {
            type: 'rack_spCode',
            label: 'SP编号',
            minWidth: '10%',
          },
          {
            type: 'room_name',
            label: '房间名称',
            minWidth: '5%',
          },
          {
            type: 'rack_belongtype',
            label: '机架属主',
            minWidth: '5%',
          },
          {
            type: 'rack_type',
            label: '机架类型',
            minWidth: '5%',
          },
          {
            type: 'rack_billingMethod',
            label: '机架计费模式',
            minWidth: '5%',
          },   {
            type: 'rack_isCage',
            label: '是否属于围笼',
            minWidth: '5%',
          },
            {
            type: 'rack_lifespan',
            label: '机架生命周期',
            minWidth: '5%',
          },
          {
            type: 'rack_IsOpen',
            label: '是否开电',
            minWidth: '5%',
          },
          {
            type: 'rack_isVirtual',
            label: '是否虚拟',
            minWidth: '5%',
          },
          {
            type: 'rack_availablePow',
            label: '可用功率(W)',
            minWidth: '5%',
          },
          {
            type: 'rack_avgAbleCur',
            label: '平均可用电流(A)',
            minWidth: '5%',
          },  {
            type: 'rack_cityPower',
            label: '市电',
            minWidth: '5%',
          },
          {
            type: 'rack_dieselPower',
            label: '柴油发电机',
            minWidth: '5%',
          },
          {
            type: 'rack_height',
            label: '机架高度',
            minWidth: '5%',
          },
          {
            type: 'rack_maxPower',
            label: '峰值功率(W)',
            minWidth: '5%',
          },
          {
            type: 'rack_netCableWay',
            label: '网络走线方式',
            minWidth: '5%',
          },
          {
            type: 'rack_peakCurr',
            label: '峰值电流(A)',
            minWidth: '5%',
          },
          {
            type: 'rack_powerRoute',
            label: '配电路由',
            minWidth: '5%',
          }, {
            type: 'idcUnit_name',
            label: '管理单元',
            minWidth: '5%',
          },
        ]
      },

    },
    data() {
      return {
        resourceData: [],
        totalNum: 0,
        currentPage: 1,
        pageSize: 10,
      };
    },
    watch: {
      ResourceData: {
        immediate: true,  // 立即执行一次
        deep: true,       // 深度监听
        handler(newVal) {
          if (newVal && newVal.length) {
            this.resourceData = [...newVal]; // 创建新数组引用
            this.totalNum = newVal.length;
            this.currentPage = 1; // 重置页码
          }
        }
      }
    },
    created() {
      // 初始化时如果有数据直接加载
      console.log("表格初始化操作");
      if (this.ResourceData && this.ResourceData.length) {
        this.resourceData = [...this.ResourceData];
        this.totalNum = this.ResourceData.length;
      }
    },
    computed: {
      paginatedData() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        return this.resourceData.slice(start, end);
      },
    },
    methods: {
      getColumnWidth(type) {
        if (this.colType) {
          return undefined; // 或者你想要的默认宽度
        } else {
          return type === 'a0' ? '100' : '150';
        }
      },
  
      changePage(val) {
        this.currentPage = val;
      },
  
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1; // 重置到第一页
      },
    },
  };
  </script>
  
